import image from "fragments/image"
import mas from "fragments/mas/mas"
import gql from "graphql-tag"

const SEARCH_HOME_VIDEO_REVIEWS = gql`
  ${image}
  ${mas}

  query searchHomeVideoReviews(
    $searchHomeVideoReviewsInput: SearchHomeVideoReviewsInput!
  ) {
    searchHomeVideoReviews(
      searchHomeVideoReviewsInput: $searchHomeVideoReviewsInput
    ) {
      id
      images {
        ...Image
      }
      mas {
        ...MAS
      }
      homeVideo {
        editions
        isBluRay
        isUHD
        newsCount
      }
      name
    }
  }
`

export default SEARCH_HOME_VIDEO_REVIEWS
